import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ButtonWrapper } from '../../components';

const ServerError = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <div className="row">
        <div className="Node ServerError col-12 col-lg-8 offset-lg-2">
          <h1>{t('pages.500.title')}</h1>
          <p>{t('pages.500.body', { pagename: window.location.href })}</p>
          <ButtonWrapper primary href={window.location.href}>{t('pages.500.primary_button.link')}</ButtonWrapper>
        </div>
      </div>
    </Container>
  );
};

export default ServerError;
